import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { StyleColor, NewStyleColor } from '../../../../utils/styles-constants';
import { hexToRgba } from '../../../../utils/style';

const Label = styled(Translate)`
	display: block;
	margin-bottom: 10px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 16px;
	line-height: 20px;
	color: ${NewStyleColor.Black};
`;

const FileName = styled('div')`
	position: relative;
	margin-bottom: 15px;
	padding-left: 30px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 15px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.Black, 55)};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	> svg {
		position: absolute;
		top: 0;
		left: 0;
		width: 20px;
		height: 20px;
		fill: currentColor;
	}
`;

const Button = styled('button')`
	width: 100%;
	height: 44px;
	padding: 0;
	border-radius: 6px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 20px;
	color: ${hexToRgba(NewStyleColor.Black, 55)};
	background-color: ${NewStyleColor.White};
	cursor: pointer;

	&:not(:last-child) {
		margin-bottom: 4px;
	}
`;

const ButtonBack = styled('button')`
	position: relative;
	height: 16px;
	margin-bottom: 15px;
	padding: 0;
	padding-left: 20px;
	border: 0;
	outline: 0;
	font-family: HelveticaNeue, sans-serif;
	font-weight: 700;
	font-size: 13px;
	line-height: 16px;
	color: ${StyleColor.Blue600};
	background-color: transparent;
	cursor: pointer;

	svg {
		position: absolute;
		top: -3px;
		left: 0;
		width: 16px;
		height: 20px;
		fill: currentColor;
	}
`;

export {
	Label,
	FileName,
	Button,
	ButtonBack,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/MediaPanel/styles.ts